import React, { FC, useEffect } from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { PostsEditContainer } from '../../components/posts/PostEditContainer';

const PostEditPage: FC = () => {
  const navigate = useNavigate();
  const { me } = useAuth();

  useEffect(() => {
    if (!me) return;
    if (!me?.isSuperuser && !me?.role?.viewCMS) navigate('/');
  }, [me, me?.isSuperuser, me?.role?.viewCMS, navigate])

  return (
    <Box>
      <PostsEditContainer />
    </Box>
  );
};

export default PostEditPage;
